import CustomForm from "../../CustomForm";
import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import SliderBox from "../../shared/components/SliderBox/SliderBox";
import {SliderItem} from "../../../model/items/slider";

export default class KandidatiUcast extends CustomForm {

    public readonly unit: string;
    public readonly steps: number[];
    public readonly decimalPlaces: number;

    private readonly slider: SliderItem;
    private readonly sliderBox: SliderBox;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.unit = settings.form.aux1 || '';
        this.steps = [Number(settings.form.aux2 || 0) || 0, Number(settings.form.aux3 || 0) || 0].sort();
        this.decimalPlaces = (''+(this.steps[0] ?? '')).split('.')[1]?.length || 0;

        const layout = settings.form.grid.layout;

        this.slider = <SliderItem>layout[0][0].cellItems[0];
        this.sliderBox = new SliderBox( <SliderItem>layout[0][0].cellItems[0], null, null, "numeric");
        this.sliderBox.setOnChange(v => this.setValue(v));
    }

    checkRequirements(): boolean {
        if (!this.slider) {
            console.warn("customForm-kandidati-finale: Missing slider on position [0][0].")
            return false;
        }

        return super.checkRequirements();
    }

    private getValue(): number {
        return Number(this.slider.getVariable() ?? this.slider.initialValue ?? 0);
    }

    private getFormattedValue(): string {
        const options: Intl.NumberFormatOptions = {
            minimumFractionDigits: this.decimalPlaces,
            maximumFractionDigits: this.decimalPlaces,
        };
        return (this.getValue().toLocaleString(undefined, options)+' '+this.unit).trim();
    }


    private setValue(value: number): void {
        const min = this.slider.range.min;
        const max = this.slider.range.max;

        value = Math.min( max, Math.max(min, value));
        this.slider.setVariable( value );
    }

    private mutateValue(diff: number): void {
        this.setValue( this.getValue() + diff );
    }

    private viewButtons(): Vnode {
        return m('.ucast-buttons', {}, [
            m( '.ucast-buttons-minus', {}, this.steps.map(s => m('button.btn', {
                tabindex: 1,
                onclick: () => this.mutateValue(-s),
            }, '-'+s.toLocaleString())).reverse() ),
            m( '.ucast-buttons-plus', {}, this.steps.map(s => m('button.btn', {
                tabindex: 1,
                onclick: () => this.mutateValue(s),
            }, '+'+s.toLocaleString())) ),
        ])
    }

    public view(): Vnode {
        const isSet = this.slider.getVariable() !== undefined;
        return this.viewLayout([
            m('.ucast'+(isSet?'.has-value':''), {},this.getFormattedValue()),
            m('.ucast-controls', {}, [
                m(this.sliderBox),
                this.viewButtons(),
            ])
        ]);
    }

}